import { Outlet, useMatch } from "react-router-dom";
import { PageBreadcrumb } from "@/components/page-breadcrumb";
import { RouteTabs } from "@/components/nav/route-tabs";
import { useAuthStore } from "@/lib/swr";
import SyncMyDocsDialog from "@/screens/User/sync-my-docs";

// /prds: two route tabs (owner 2026-09-08) — My PRDs (owner ∪ member, the
// work queue with stage buckets) and All PRDs (everything under my visible
// apps). Route-driven so a detail-page round-trip lands on the same tab.
// Doc sync is a self-service action of the My tab only.
const PrdsLayout = () => {
  const userId = useAuthStore((s) => s.auth?.user?.id as string | undefined);
  const onMyTab = !!useMatch({ path: "/prds", end: true });
  return (
    <div className="flex flex-col gap-2">
      <PageBreadcrumb current="PRDs" className="mb-0" />
      <RouteTabs
        items={[
          { name: "My PRDs", to: "/prds", end: true },
          { name: "All PRDs", to: "/prds/all" },
        ]}
        action={
          onMyTab && userId ? <SyncMyDocsDialog userId={userId} /> : undefined
        }
      />
      <Outlet />
    </div>
  );
};

export default PrdsLayout;
